import { render, staticRenderFns } from "./FormPhoneType.vue?vue&type=template&id=a7215038"
import script from "./FormPhoneType.vue?vue&type=script&lang=js"
export * from "./FormPhoneType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports